document.addEventListener('DOMContentLoaded', function() {

  const twoColumnSections = document.querySelectorAll('.twoColumnSection');

  twoColumnSections.forEach(section => {
    if ($(section).hasClass('slick-initialized')) {
      return;
    }

    $(section).slick({
      arrows: false,
      autoplay: false,
      dots: true,
      infinite: true,
      mobileFirst: true,
      slidesToScroll: 1,
      slidesToShow: 1,
      responsive: [
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 2
          }
        }
      ]
    });
  });

  // Initialise the Watch Sliders
  const watchSliderCarousels = document.querySelectorAll('.watchSlider__Carousel');

  watchSliderCarousels.forEach(carousel => {
    const isSpecialEditionsSlider = carousel.closest('.specialEditionsSlider') !== null;
    const specialEditionsSection = isSpecialEditionsSlider ? carousel.closest('.specialEditionsSlider') : null;
    const backgroundSlider = specialEditionsSection ? specialEditionsSection.querySelector('.specialEditions__BackgroundSlider') : null;

    function syncSpecialEditionContentTheme(index) {
      if (!specialEditionsSection) {
        return;
      }

      const slide = $(carousel).find('.watchSlider__Slide').eq(index);
      const isDarkModeContent = slide.data('dark-mode-content') === true || slide.attr('data-dark-mode-content') === 'true';

      specialEditionsSection.classList.toggle('specialEditionsSlider--DarkModeContent', isDarkModeContent);
    }

    if (backgroundSlider && !$(backgroundSlider).hasClass('slick-initialized')) {
      $(backgroundSlider).slick({
        asNavFor: carousel,
        arrows: false,
        dots: false,
        draggable: false,
        fade: true,
        infinite: false,
        slidesToScroll: 1,
        slidesToShow: 1,
        speed: 400,
        swipe: false,
        touchMove: false
      });
    }

    const carouselSettings = {
      arrows: true,
      dots: isSpecialEditionsSlider,
      infinite: false,
      prevArrow: $(carousel).parent().find('.watchSlider__Prev'),
      nextArrow: $(carousel).parent().find('.watchSlider__Next'),
      slidesToScroll: 1,
      slidesToShow: 1
    };

    if (backgroundSlider) {
      carouselSettings.asNavFor = backgroundSlider;
    }

    $(carousel).slick(carouselSettings);

    if (specialEditionsSection) {
      $(carousel).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        syncSpecialEditionContentTheme(nextSlide);
      });

      syncSpecialEditionContentTheme($(carousel).slick('slickCurrentSlide'));
    }

    // Handle setting the background gradient colours
    function setBackgroundGradient() {
      const parent = $(carousel).parent()[0];
      let primaryColor = $(carousel).find('.watchSlider__Slide:first-child').data('primary-color');
      let secondaryColor = $(carousel).find('.watchSlider__Slide:first-child').data('secondary-color');

      if (parent) {
        parent.style.setProperty('--primary-color', primaryColor);
        parent.style.setProperty('--secondary-color', secondaryColor);
      }

      // Handle updating the background gradient colours when the slider changes
      $(carousel).on('afterChange', function() {
        const currentSlide = $(carousel).find('.slick-current .watchSlider__Slide');

        primaryColor = currentSlide.data('primary-color');
        secondaryColor = currentSlide.data('secondary-color');

        if (parent) {
          parent.style.setProperty('--primary-color', primaryColor);
          parent.style.setProperty('--secondary-color', secondaryColor);
        }
      });
    }

    setBackgroundGradient();
  });

  // Initialise generic sliders
  const sliders = document.querySelectorAll('.slider');

  sliders.forEach(slider => {
    const wrapper = slider.closest('.slider__Wrapper');
    const dotsContainer = wrapper.querySelector('[data-slider-dots]');

    const desktopSlides = parseFloat(wrapper.dataset.desktopSlides) || 3.1;
    const tabletSlides  = parseFloat(wrapper.dataset.tabletSlides)  || 2.1;
    const mobileSlides  = parseFloat(wrapper.dataset.mobileSlides)  || 1.1;

    $(slider).slick({
      dots: false,
      appendDots: dotsContainer,
      slidesToScroll: 1,
      slidesToShow: desktopSlides,
      infinite: false,
      arrows: true,
      prevArrow: wrapper.querySelector('.slider__Prev'),
      nextArrow: wrapper.querySelector('.slider__Next'),
      responsive: [
        {
          breakpoint: 640,
          settings: {
            arrows: false,
            dots: true,
            slidesToShow: mobileSlides
          }
        },
        {
          breakpoint: 1024,
          settings: {
            arrows: false,
            dots: true,
            slidesToShow: tabletSlides
          }
        },
        {
          breakpoint: 9999,
          settings: {
            arrows: true,
            dots: false,
            slidesToShow: desktopSlides
          }
        }
      ]
    });
  });
});
